import React, { Component } from 'react';

import GoalsViewCentral from './GoalsViewCentral';
import ContestsViewCentral from './ContestsViewCentral';
import TargetsViewCentral from './TargetsViewCentral';

export default class SettingsViewCentral extends Component {

    constructor(props) {
        super(props);

        this.defaultProps = {}

        this.state = {

        }

        this.getPages = this.getPages.bind(this);
    }

    componentDidMount() {

    }

    componentWillReceiveProps() {

    }

    componentWillUnmount() {

    }

    getPages() {
        let pages = [];
        for (var i = 0; i < this.props.links.length; i++) {

            //let whereClass = '';
            // if (this.props.links[i].index === this.props.activeIndex) {
            //     whereClass = 'container-active';
            // } else if (this.props.links[i].index < this.props.activeIndex) {
            //     whereClass = 'container-left';
            //     if (this.props.activeIndex < this.lastActiveIndex) {
            //         whereClass += ' z2';
            //     }
            // } else if (this.props.links[i].index > this.props.activeIndex) {
            //     whereClass = 'container-right';
            //     if (this.props.activeIndex > this.lastActiveIndex) {
            //         whereClass += ' z2';
            //     }
            // }

            let objStyle = { left: Math.floor(100 * (this.props.links[i].index - this.props.activeIndex)) + '%' }

            switch (this.props.links[i].label) {
                case 'Targets':
                    pages.push((
                        <TargetsViewCentral
                            accountInfo={this.props.accountInfo}
                            reportKPIs={this.props.reportKPIs}
                            style={objStyle}
                            mode={this.props.mode}
                            isActive={this.props.activeIndex === this.props.links[i].index}
                            handleScrollTop={this.props.handleScrollTop}
                            handleNavChange={this.props.handleNavChange}
                            targets={this.props.targets}
                            activeTargetKpi={this.props.activeTargetKpi}
                            handleSelectTarget={this.props.handleSelectTarget}
                            handleDrillTarget={this.props.handleDrillTarget}
                            selectTargetCalendarDay={this.props.selectTargetCalendarDay}
                            selectTargetCalendarDayAll={this.props.selectTargetCalendarDayAll}
                        />
                    ));
                    break;
                case 'Goals':
                    pages.push((
                        <GoalsViewCentral
                            loadingOn={this.props.loadingOff}
                            loadingOff={this.props.loadingOn}
                            accountInfo={this.props.accountInfo}
                            users={this.props.users}
                            reportKPIs={this.props.reportKPIs}
                            calendarDates={this.props.calendarDates}
                            style={objStyle}
                            mode={this.props.mode}
                            isActive={this.props.activeIndex === this.props.links[i].index}
                            handleScrollTop={this.props.handleScrollTop}
                            handleNavChange={this.props.handleNavChange}
                            handleModeChange={this.props.handleModeChange}
                            goals={this.props.goals}
                            selectedGoalId={this.props.selectedGoalId}
                            activeGoal={this.props.activeGoal}
                            handleSelectGoal={this.props.handleSelectGoal}
                            handleAddGoalData={this.props.handleAddGoalData}
                            handleDelete={this.props.handleDeleteGoal}
                            handleArchive={this.props.handleGoalArchive}
                            handleSave={this.props.handleSaveGoal}
                        />
                    ));
                    break;
                case 'Contests':
                    pages.push((
                        <ContestsViewCentral
                            loadingOn={this.props.loadingOff}
                            loadingOff={this.props.loadingOn}
                            reloadPage={this.props.reloadPage}
                            accountInfo={this.props.accountInfo}
                            groupMap={this.props.groupMap}
                            groupMapReverse={this.props.groupMapReverse}
                            locationMap={this.props.locationMap}
                            locationMapReverse={this.props.locationMapReverse}
                            locationKpiMap={this.props.locationKpiMap}
                            locationKpiMapReverse={this.props.locationKpiMapReverse}
                            employeeKpiMap={this.props.employeeKpiMap}
                            employeeKpiMapReverse={this.props.employeeKpiMapReverse}
                            masterKpiMap={this.props.masterKpiMap}
                            masterKpiMapReverse={this.props.masterKpiMapReverse}
                            users={this.props.users}
                            reportKPIs={this.props.reportKPIs}
                            calendarDates={this.props.calendarDates}
                            style={objStyle}
                            mode={this.props.mode}
                            isActive={this.props.activeIndex === this.props.links[i].index}
                            handleScrollTop={this.props.handleScrollTop}
                            handleNavChange={this.props.handleNavChange}
                            handleModeChange={this.props.handleModeChange}
                            rankedContests={this.props.rankedContests}
                            raffleContests={this.props.raffleContests}
                            selectedContestId={this.props.selectedContestId}
                            activeContest={this.props.activeContest}
                            handleSelectContest={this.props.handleSelectContest}
                            handleDelete={this.props.handleDeleteContest}
                            handleArchive={this.props.handleContestArchive}
                            handleSave={this.props.handleSaveContest}
                            saveContestResult={this.props.saveContestResult}
                            setRaffleWinner={this.props.setRaffleWinner}
                        />
                    ));
                    break;
            }
        }

        this.lastActiveIndex = this.props.activeIndex;
        return pages;
    }

    render() {

        let pages = this.getPages();

        let outerStyle = {};
        if (this.props.mode === 'new' || this.props.mode === 'info' || this.props.mode === 'edit' || this.props.mode === 'results') {
            outerStyle.height = 'calc(100% - 5.5rem)';
        }

        return (
            <div className="settings-central-outer" style={outerStyle}>
                {pages}
            </div>
        );
    }
}